import React, { useCallback,useContext } from 'react'

import cx from 'classnames'

import RightSidebar from 'components/RightSidebar'
import { Card,OpenedSidebar, SidebarOpenContext } from 'context/sidebarOpenContext'
import { getEndUserDisplayInfo } from 'utils/endUser'

import ContactAboutCard, { ContactAboutCardHeader } from './AboutCard'
import { RecentActivityCard, RecentActivityCardHeader } from './RecentActivityCard'
import { SFDCCard, SFDCHeader } from './SFDCCard'

import styles from './styles.module.css'

interface ExpandableSectionProps {
  expanded: boolean
  renderSectionHeader: ({
    expandable,
    expanded
  }: {
    expandable: boolean
    expanded: boolean
  }) => React.ReactElement
  children: React.ReactElement
  onClick: () => void
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  expanded,
  renderSectionHeader,
  children,
  onClick
}) => {
  return (
    <div className={styles.expandableSection}>
      <div className={styles.expandableSectionHeader} onClick={onClick}>
        {renderSectionHeader({ expandable: true, expanded })}
      </div>
      <div className={cx(styles.expandableContent, { [styles.expanded]: expanded })}>
        {expanded && children}
      </div>
      <div className={styles.bottomSectionBorder}></div>
    </div>
  )
}

export const ContactSidebar: React.FC = () => {
  const {
    setOpenedRightSidebar,
    expandedCard,
    setExpandedCard,
    setSidebarContact,
    sidebarContact
  } = useContext(SidebarOpenContext)

  const toggleExpandedCard = useCallback(
    (card: Card) => {
      if (expandedCard === card) {
        setExpandedCard(Card.NONE)
      } else {
        setExpandedCard(card)
      }
    },
    [expandedCard, setExpandedCard]
  )

  if (!sidebarContact) {
    return <></>
  }

  return (
    <RightSidebar
      header={'Contact details'}
      subHeader={<div className={styles.contactRole}>{getEndUserDisplayInfo(sidebarContact)}</div>}
      onCollapse={() => {
        setOpenedRightSidebar(OpenedSidebar.NONE)
        setSidebarContact(undefined)
      }}>
      <div className={styles.detailsSidebarContentContainer}>
        <ExpandableSection
          renderSectionHeader={props => <ContactAboutCardHeader {...props} />}
          expanded={expandedCard === Card.CONTACT}
          onClick={() => toggleExpandedCard(Card.CONTACT)}>
          <ContactAboutCard contact={sidebarContact} />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <SFDCHeader {...props} />}
          expanded={expandedCard === Card.SALESFORCE_CARD}
          onClick={() => toggleExpandedCard(Card.SALESFORCE_CARD)}>
          <SFDCCard contact={sidebarContact} />
        </ExpandableSection>
        <ExpandableSection
          renderSectionHeader={props => <RecentActivityCardHeader {...props} />}
          expanded={expandedCard === Card.RECENT_ACTIVITY}
          onClick={() => toggleExpandedCard(Card.RECENT_ACTIVITY)}>
          <RecentActivityCard endUserId={sidebarContact.id} />
        </ExpandableSection>
      </div>
    </RightSidebar>
  )
}

export default ContactSidebar
